import { useState, useEffect } from 'react';
import { auth, db } from '../config/firebase';
import { collection, getDocs } from 'firebase/firestore';

export default function FirebaseTestPage() {
  const [status, setStatus] = useState({
    config: 'Checking...',
    firebase: 'Checking...',
    firestore: 'Checking...',
    details: []
  });

  useEffect(() => {
    const checkFirebase = async () => {
      const details = [];
      
      // Check environment variables
      const config = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
      };

      const allSet = Object.values(config).every(v => v && v !== 'undefined');
      
      details.push('=== Environment Variables ===');
      Object.entries(config).forEach(([key, value]) => {
        if (value && value !== 'undefined') {
          details.push(`✓ ${key}: ${value.substring(0, 20)}...`);
        } else {
          details.push(`✗ ${key}: MISSING`);
        }
      });

      setStatus(prev => ({
        ...prev,
        config: allSet ? '✓ All Set' : '✗ Missing Variables',
        details
      }));

      // Check Firebase initialization
      if (auth && db) {
        details.push('\n=== Firebase Initialization ===');
        details.push('✓ Firebase Auth initialized');
        details.push('✓ Firestore initialized');
        
        setStatus(prev => ({
          ...prev,
          firebase: '✓ Initialized',
          details
        }));

        // Test Firestore connection
        try {
          details.push('\n=== Firestore Connection Test ===');
          const testCollection = collection(db, 'rooms', 'general', 'messages');
          const snapshot = await getDocs(testCollection);
          details.push(`✓ Firestore connected (found ${snapshot.size} messages)`);
          setStatus(prev => ({
            ...prev,
            firestore: '✓ Connected',
            details
          }));
        } catch (error) {
          details.push(`✗ Firestore error: ${error.message}`);
          details.push(`  Code: ${error.code}`);
          setStatus(prev => ({
            ...prev,
            firestore: `✗ Error: ${error.code}`,
            details
          }));
        }
      } else {
        details.push('\n=== Firebase Initialization ===');
        details.push('✗ Firebase not initialized');
        details.push('  Check console for configuration errors');
        setStatus(prev => ({
          ...prev,
          firebase: '✗ Not Initialized',
          details
        }));
      }
    };

    checkFirebase();
  }, []);

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Firebase Setup Verification</h1>
      
      <div style={{ marginTop: '30px' }}>
        <h2>Status</h2>
        <div style={{ 
          background: '#f5f5f5', 
          padding: '20px', 
          borderRadius: '8px',
          marginTop: '10px'
        }}>
          <div style={{ marginBottom: '10px' }}>
            <strong>Environment Variables:</strong> {status.config}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>Firebase Initialization:</strong> {status.firebase}
          </div>
          <div>
            <strong>Firestore Connection:</strong> {status.firestore}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '30px' }}>
        <h2>Details</h2>
        <pre style={{ 
          background: '#1e1e1e', 
          color: '#d4d4d4',
          padding: '20px', 
          borderRadius: '8px',
          overflow: 'auto',
          fontSize: '13px',
          lineHeight: '1.6'
        }}>
          {status.details.join('\n')}
        </pre>
      </div>

      <div style={{ marginTop: '30px', padding: '20px', background: '#fff3cd', borderRadius: '8px' }}>
        <h3>Next Steps:</h3>
        <ol>
          <li>If environment variables are missing, check your <code>.env</code> file in <code>client/</code> directory</li>
          <li>If Firebase is not initialized, restart your React dev server</li>
          <li>If Firestore connection fails, make sure Firestore Database is enabled in Firebase Console</li>
          <li>Check browser console for detailed error messages</li>
        </ol>
      </div>
    </div>
  );
}

